// @flow
import { CALL_API } from '../../api';
import * as ActionTypes from './auth.actionTypes';
import schema from '../../api/schema';
import { RESET_STATE } from '@redux-offline/redux-offline/lib/constants';

const postAuthToken = token => ({
  type: ActionTypes.LOGIN_REQUEST_TOKEN,
  meta: {
    offline: {
      effect: {
        endpoint: `auth/authToken`,
        schema: schema.authResponseSchema,
        requestInit: {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify({
            authToken: token,
          }),
        },
      },
      commit: {
        type: ActionTypes.LOGIN_SUCCESS,
      },
      rollback: {
        type: ActionTypes.LOGIN_FAILURE,
      },
    },
  },
});
const postAuthTokenAsync = token => ({
  [CALL_API]: {
    types: [ActionTypes.LOGIN_REQUEST, ActionTypes.LOGIN_SUCCESS, ActionTypes.LOGIN_FAILURE],
    endpoint: `auth/authToken`,
    schema: schema.authResponseSchema,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        authToken: token,
      }),
    },
  },
});

const postLoginCredentials = credentials => ({
  [CALL_API]: {
    types: [ActionTypes.LOGIN_REQUEST, ActionTypes.LOGIN_SUCCESS, ActionTypes.LOGIN_FAILURE],
    endpoint: `auth/local`,
    schema: schema.authResponseSchema,
    authFailHandling: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        email: credentials.username,
        password: credentials.password,
      }),
    },
  },
});

const doLogout = () => ({
  [CALL_API]: {
    types: [ActionTypes.LOGOUT_REQUEST, ActionTypes.LOGOUT_SUCCESS, ActionTypes.LOGOUT_FAILURE],
    endpoint: `auth/local/logout`,
    authorization: true,
  },
});

export const loginUserToken = token => (dispatch, getState) => {
  if (!token) {
    localStorage.removeItem('wihuri-mia-token');
    localStorage.clear('persist:wihuri-mia');
    dispatch({ type: RESET_STATE });
    return dispatch({
      type: ActionTypes.AUTH_INVALIDATE,
    });
  }

  return dispatch(postAuthToken(token));
};

export const loginUserTokenAsync = token => (dispatch, getState) => {
  if (!token) {
    localStorage.removeItem('wihuri-mia-token');
    localStorage.clear('persist:wihuri-mia');
    dispatch({ type: RESET_STATE });
    return dispatch({
      type: ActionTypes.AUTH_INVALIDATE,
    });
  }

  return dispatch(postAuthTokenAsync(token));
};

export const loginUser = credentials => (dispatch, getState) => {
  return dispatch(postLoginCredentials(credentials)).then(response => {
    if (response.type === ActionTypes.LOGIN_SUCCESS) {
      //TODO Centralized token handling
      localStorage.setItem('wihuri-mia-token', response.response.result.token);
    } else {
      //TODO Centralized token handling
      localStorage.removeItem('wihuri-mia-token');
      localStorage.clear('persist:wihuri-mia');
    }
    return Promise.resolve(response);
  });
};

export const logoutUser = () => (dispatch, getState) => {
  return dispatch(doLogout())
    .then(response => {
      dispatch({ type: RESET_STATE });
      localStorage.removeItem('wihuri-mia-token');
      localStorage.clear('persist:wihuri-mia');
      // window.location.replace('/');
      window.history.replaceState(null, '', '/');
    })
    .catch(error => {
      localStorage.removeItem('wihuri-mia-token');
      localStorage.clear('persist:wihuri-mia');
      // window.location.replace('/');
      window.history.replaceState(null, '', '/');
    });
};

export const setUrlAfterLogin = url => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.URL_AFTER_LOGIN,
    url,
  });
};



// WEBPACK FOOTER //
// ./src/modules/auth/auth.actions.js